import { Flex, Icon, Text } from '@homebotapp/hb-react-component-catalog'
import { format, parseISO } from 'date-fns'
import { defineMessages, useIntl } from 'react-intl'
import { useSelector } from 'react-redux'
import { Helpers } from '../../../../quartermaster/src'
import { selectHomeSoldDate } from '../../../../store/selectors/home'
import { selectHomeValue } from '../../../../store/selectors/home/metadata'
import { RootState } from '../../../../types/rootState'

export const MSG = defineMessages({
  high: {
    id: 'Homeowner.estimatedValue.appreciatedPercentHigh',
    defaultMessage: ' since purchased in {year}!'
  },
  low: {
    id: 'Homeowner.estimatedValue.appreciatedPercentLow',
    defaultMessage: ' since purchased in {year}'
  },
  up: {
    id: 'Homeowner.estimatedValue.up',
    defaultMessage: "That's up {percent}% {message}"
  },
  down: {
    id: 'Homeowner.estimatedValue.down',
    defaultMessage: "That's down {percent}% {message}"
  }
})

export interface AppreciationSentenceProps {
  withCurrentHomeData: boolean
}

export const AppreciationSentence = ({ withCurrentHomeData }: AppreciationSentenceProps) => {
  const intl = useIntl()
  const homeSoldDate = useSelector(selectHomeSoldDate)
  const homeValue: number = useSelector(selectHomeValue)
  const homeSoldPrice = useSelector<RootState, number>(state => state.home.data?.soldPrice)
  const pct: number = Helpers.getAppreciationPercent(homeValue, homeSoldPrice)

  if (!pct || !homeValue || !homeSoldDate || !homeSoldPrice || !withCurrentHomeData) {
    return null
  }

  const message = intl.formatMessage(pct < 4 ? MSG.low : MSG.high, {
    year: format(parseISO(homeSoldDate), 'y')
  })

  return (
    <Flex gap={1} align='center' justify='center'>
      <Text size='sm' fontWeight='bold' color={pct >= 0 ? 'success' : 'danger'}>
        <Icon name={pct >= 0 ? 'triangle-up' : 'triangle-down'} />
      </Text>
      <Text size='sm' fontWeight='bold' color={pct >= 0 ? 'success' : 'danger'}>
        {Math.abs(pct)}%
      </Text>
      <Text size='sm' aria-hidden='true'>
        {message}
      </Text>
      <p className='screenReaderText' data-qa='qa-appreciation-sentence-a11y'>
        {intl.formatMessage(pct < 0 ? MSG.down : MSG.up, {
          percent: Math.abs(pct),
          message: message
        })}
      </p>
    </Flex>
  )
}
